import React from 'react';

const Section = ({ num, title, children }) => (
  <div style={{
    background: '#0f0f22',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 20,
    padding: '28px 24px',
    marginBottom: 20,
  }}>
    <div style={{ display:'flex', alignItems:'center', marginBottom:16 }}>
      <div style={{
        width:32, height:32, borderRadius:10,
        background:'linear-gradient(135deg,#00d4aa,#00836b)',
        display:'flex', alignItems:'center', justifyContent:'center',
        fontSize:14, fontWeight:900, color:'#fff', marginRight:12, flexShrink:0,
      }}>{num}</div>
      <span style={{ fontSize:17, fontWeight:800, color:'#fff' }}>{title}</span>
    </div>
    {children}
  </div>
);

const P = ({ children }) => (
  <p style={{ color:'rgba(255,255,255,0.55)', fontSize:14, lineHeight:1.7, marginBottom:12 }}>{children}</p>
);

const UL = ({ items }) => (
  <ul style={{ color:'rgba(255,255,255,0.55)', fontSize:14, paddingLeft:20, marginBottom:12 }}>
    {items.map((item,i) => <li key={i} style={{ marginBottom:8 }}>{item}</li>)}
  </ul>
);

const Highlight = ({ children }) => (
  <div style={{
    background:'rgba(0,212,170,0.08)',
    border:'1px solid rgba(0,212,170,0.25)',
    borderRadius:14, padding:'16px 20px', margin:'16px 0',
  }}>
    <p style={{ color:'rgba(255,255,255,0.8)', fontSize:14, lineHeight:1.7, margin:0 }}>{children}</p>
  </div>
);

export default function TermsOfService() {
  return (
    <div style={{ background:'#04040e', minHeight:'100vh', color:'#fff', fontFamily:"'Segoe UI',Arial,sans-serif", padding:'0 16px 60px' }}>

      {/* Header */}
      <div style={{
        background:'linear-gradient(135deg,rgba(0,212,170,0.12),rgba(0,212,170,0.04))',
        borderBottom:'1px solid rgba(255,255,255,0.08)',
        padding:'32px 24px 28px', textAlign:'center', margin:'0 -16px 40px',
      }}>
        <div style={{ display:'inline-flex', alignItems:'center', gap:12, marginBottom:16 }}>
          <div style={{
            width:48, height:48, borderRadius:14,
            background:'linear-gradient(135deg,#00d4aa,#00836b)',
            display:'flex', alignItems:'center', justifyContent:'center', fontSize:24,
          }}>✦</div>
          <span style={{ fontSize:26, fontWeight:900 }}>
            Tecki<span style={{ color:'#00d4aa' }}>A</span>
          </span>
        </div>
        <div style={{ fontSize:18, color:'rgba(255,255,255,0.55)', marginBottom:8 }}>
          Conditions Générales d'Utilisation
        </div>
        <div style={{ fontSize:12, color:'rgba(0,212,170,0.7)', fontWeight:700, letterSpacing:0.5 }}>
          Dernière mise à jour : 15 mars 2026
        </div>
      </div>

      <div style={{ maxWidth:760, margin:'0 auto' }}>

        {/* Intro */}
        <div style={{ background:'#0f0f22', border:'1px solid rgba(255,255,255,0.08)', borderRadius:20, padding:'28px 24px', marginBottom:20 }}>
          <Highlight>
            En utilisant TeckiA, vous acceptez les présentes Conditions Générales d'Utilisation. Veuillez les lire attentivement avant d'utiliser nos services.
          </Highlight>
          <P>TeckiA est un assistant personnel intelligent développé par <strong style={{color:'#fff'}}>TDI Digital LLC</strong>, société enregistrée aux États-Unis. TeckiA vous permet de gérer vos emails, votre agenda, vos tâches et d'interagir avec une IA vocale avancée.</P>
        </div>

        <Section num="1" title="Acceptation des conditions">
          <P>En téléchargeant, installant ou utilisant l'application TeckiA, vous acceptez d'être lié par les présentes CGU. Si vous n'acceptez pas ces conditions, vous ne devez pas utiliser TeckiA.</P>
          <P>Ces conditions s'appliquent à tous les utilisateurs, qu'ils utilisent la version gratuite ou premium de TeckiA.</P>
        </Section>

        <Section num="2" title="Description du service">
          <P>TeckiA propose les fonctionnalités suivantes :</P>
          <UL items={[
            <><strong style={{color:'#fff'}}>Assistant IA vocal et textuel</strong> — interaction naturelle en français et malgache</>,
            <><strong style={{color:'#fff'}}>Gestion des emails</strong> — lecture, résumé, réponse automatique via Gmail, Outlook et autres fournisseurs</>,
            <><strong style={{color:'#fff'}}>Gestion de l'agenda</strong> — création, modification et suppression d'événements Google Calendar</>,
            <><strong style={{color:'#fff'}}>Gestion des tâches</strong> — création et suivi de tâches personnelles et professionnelles</>,
            <><strong style={{color:'#fff'}}>Notifications intelligentes</strong> — rappels vocaux avant les événements importants</>,
            <><strong style={{color:'#fff'}}>Traduction</strong> — support multilingue incluant le malgache</>,
          ]}/>
        </Section>

        <Section num="3" title="Compte utilisateur et inscription">
          <P>Pour utiliser TeckiA, vous devez créer un compte avec une adresse email valide. Vous êtes responsable de :</P>
          <UL items={[
            "La confidentialité de vos identifiants de connexion",
            "Toutes les activités effectuées depuis votre compte",
            "La fourniture d'informations exactes et à jour",
          ]}/>
          <P>Vous devez avoir au moins <strong style={{color:'#fff'}}>18 ans</strong> pour utiliser TeckiA, ou l'âge légal de majorité dans votre pays de résidence.</P>
        </Section>

        <Section num="4" title="Connexion Google OAuth et accès aux données">
          <P>TeckiA peut se connecter à votre compte Google pour accéder à Gmail et Google Calendar. En autorisant cette connexion, vous acceptez que TeckiA :</P>
          <UL items={[
            "Lise vos emails pour vous fournir des résumés et suggestions",
            "Envoie des emails en votre nom, uniquement sur votre instruction explicite",
            "Accède à votre Google Calendar pour afficher et gérer vos événements",
            "Crée, modifie ou supprime des événements sur votre instruction",
          ]}/>
          <Highlight>
            ⚠️ TeckiA n'accède jamais à vos données Google sans votre consentement explicite. Vous pouvez révoquer l'accès à tout moment depuis les paramètres de l'application ou depuis votre compte Google (myaccount.google.com/permissions).
          </Highlight>
          <P>L'utilisation des données Google est conforme aux Politiques de données des API Google, notamment la politique d'utilisation limitée des données.</P>
        </Section>

        <Section num="5" title="Utilisation acceptable">
          <P>Vous vous engagez à utiliser TeckiA uniquement à des fins légales. Il est strictement interdit de :</P>
          <UL items={[
            "Utiliser TeckiA pour envoyer des communications non sollicitées (spam)",
            "Tenter d'accéder aux comptes ou données d'autres utilisateurs",
            "Utiliser TeckiA pour des activités illégales ou frauduleuses",
            "Tenter de contourner les mesures de sécurité de l'application",
            "Reproduire, modifier ou distribuer TeckiA sans autorisation écrite de TDI Digital LLC",
            "Utiliser TeckiA pour harceler, menacer ou nuire à d'autres personnes",
          ]}/>
        </Section>

        <Section num="6" title="Propriété intellectuelle">
          <P>TeckiA et tous ses composants (code source, design, logo, nom, fonctionnalités) sont la propriété exclusive de <strong style={{color:'#fff'}}>TDI Digital LLC</strong> et sont protégés par les lois applicables sur la propriété intellectuelle.</P>
          <P>L'utilisation de TeckiA ne vous confère aucun droit de propriété sur l'application ou ses composants.</P>
        </Section>

        <Section num="7" title="Tarification et abonnements">
          <P>TeckiA propose une version gratuite avec des fonctionnalités limitées et des plans premium avec accès complet.</P>
          <UL items={[
            <><strong style={{color:'#fff'}}>Version gratuite</strong> — accès limité aux fonctionnalités de base</>,
            <><strong style={{color:'#fff'}}>Plan Pro</strong> — accès complet à toutes les fonctionnalités IA</>,
            <><strong style={{color:'#fff'}}>Plan Business</strong> — fonctionnalités avancées pour les entreprises</>,
          ]}/>
          <P>Les paiements sont traités via MVola, Orange Money ou carte bancaire. Aucun remboursement n'est accordé pour les périodes déjà consommées, sauf en cas de défaillance technique imputable à TDI Digital LLC.</P>
        </Section>

        <Section num="8" title="Limitation de responsabilité">
          <P>TeckiA est fourni "tel quel" sans garantie d'aucune sorte. TDI Digital LLC ne peut être tenu responsable :</P>
          <UL items={[
            "Des erreurs ou inexactitudes dans les réponses générées par l'IA",
            "Des interruptions de service dues à des facteurs externes",
            "Des pertes de données résultant d'une utilisation incorrecte",
            "Des dommages indirects liés à l'utilisation de TeckiA",
          ]}/>
          <P>Vous êtes seul responsable des décisions prises sur la base des informations fournies par TeckiA.</P>
        </Section>

        <Section num="9" title="Protection des données personnelles">
          <P>La collecte et le traitement de vos données personnelles sont régis par notre{' '}
            <a href="https://teckia.tdidigital.io/privacy" style={{color:'#00d4aa'}}>Politique de Confidentialité</a>,
            qui fait partie intégrante des présentes CGU.
          </P>
          <P>Vous disposez des droits suivants :</P>
          <UL items={[
            "Droit d'accès à vos données personnelles",
            "Droit de rectification des données inexactes",
            "Droit à l'effacement (\"droit à l'oubli\")",
            "Droit à la portabilité de vos données",
            "Droit de retirer votre consentement à tout moment",
          ]}/>
        </Section>

        <Section num="10" title="Modifications des CGU">
          <P>TDI Digital LLC se réserve le droit de modifier les présentes CGU à tout moment. En cas de modification substantielle, vous serez notifié via l'application au moins <strong style={{color:'#fff'}}>30 jours avant</strong> l'entrée en vigueur des nouvelles conditions.</P>
        </Section>

        <Section num="11" title="Résiliation">
          <P>Vous pouvez supprimer votre compte TeckiA à tout moment depuis les paramètres de l'application. TDI Digital LLC se réserve le droit de suspendre ou résilier votre accès en cas de violation des présentes CGU.</P>
          <P>En cas de résiliation, vos données seront supprimées dans un délai de <strong style={{color:'#fff'}}>30 jours</strong>.</P>
        </Section>

        <Section num="12" title="Droit applicable et juridiction">
          <P>Les présentes CGU sont régies par le droit des États-Unis et de l'État d'enregistrement de TDI Digital LLC. Tout litige sera soumis à la juridiction compétente de cet État.</P>
          <P>Contactez-nous d'abord à <a href="mailto:contact@tdidigital.io" style={{color:'#00d4aa'}}>contact@tdidigital.io</a> avant toute procédure judiciaire.</P>
        </Section>

        {/* Contact */}
        <div style={{
          background:'linear-gradient(135deg,rgba(0,212,170,0.1),rgba(0,212,170,0.04))',
          border:'1px solid rgba(0,212,170,0.3)',
          borderRadius:20, padding:'28px 24px', textAlign:'center', marginTop:32,
        }}>
          <h3 style={{ fontSize:18, fontWeight:800, marginBottom:8 }}>Une question sur nos CGU ?</h3>
          <p style={{ color:'rgba(255,255,255,0.55)', fontSize:14, marginBottom:20 }}>
            Notre équipe est disponible pour répondre à toutes vos questions.
          </p>
          <a href="mailto:contact@tdidigital.io" style={{
            display:'inline-block',
            background:'linear-gradient(135deg,#00d4aa,#00836b)',
            color:'#fff', fontWeight:800, fontSize:14,
            padding:'12px 28px', borderRadius:12, textDecoration:'none',
          }}>✉️ Nous contacter</a>
          <p style={{ marginTop:16, fontSize:12, color:'rgba(255,255,255,0.25)' }}>
            TDI Digital LLC · États-Unis · contact@tdidigital.io
          </p>
        </div>

        {/* Footer */}
        <div style={{ textAlign:'center', padding:'32px 0 0', color:'rgba(255,255,255,0.2)', fontSize:12 }}>
          © 2026 TDI Digital LLC — TeckiA · Tous droits réservés<br/>
          <a href="https://teckia.tdidigital.io/privacy" style={{color:'rgba(0,212,170,0.5)'}}>
            Politique de Confidentialité
          </a>
        </div>

      </div>
    </div>
  );
}